import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "filterList",
    standalone: false
})
export class FilterListPipe implements PipeTransform {

  // Función para obtener el valor de una propiedad anidada
  private getNestedValue(obj: any, path: string): any {
    return path.split(".").reduce((acc, part) => acc?.[part], obj);
  }

  // Transformar la lista según el texto de búsqueda y las propiedades proporcionadas
  transform(
    items: any[],
    params?: any
  ): any {
    if (!items || !params?.searchText) {
      return items;
    }

    // Convertir el texto de búsqueda a minúsculas para una comparación insensible a mayúsculas/minúsculas
    const lowerSearchText = params.searchText.toLowerCase();

    // Buscar el primer elemento que coincida con el texto de búsqueda
    const matchedItem = items.find((item) => {
        // Obtener el valor a verificar, ya sea la propiedad específica o el elemento completo
        const valueToCheck = params.filterPropertyName
            ? this.getNestedValue(item, params.filterPropertyName)
            : item;

        // Verificar si el valor contiene el texto de búsqueda
        return String(valueToCheck).toLowerCase().includes(lowerSearchText);
    });

    // Si se encuentra un elemento coincidente, devolver el valor de la propiedad especificada (si se proporciona)
    if (matchedItem && params.propertyNameValue) {
      return this.getNestedValue(matchedItem, params.propertyNameValue);
    }

    // Devolver el elemento coincidente completo o undefined si no se encuentra ninguno
    return matchedItem;
  }
}
